const { loadScript } = require('./util/loadDependencies');

export default (jsBasePath) => {
	jQuery(($) => {
		const triggerFitVids = () => {
			$('body').fitVids();
		};

		loadScript(`${jsBasePath}./fitvids/jquery.fitvids_outside.js`, triggerFitVids);
	});
}
